import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import GoogleMap from '../../containers/GoogleMap';
import styles from './styles.scss';
import { getMapOffset, getMarkerIcon } from './helpers';

// eslint-disable-next-line react/no-deprecated
export default class OrderStatusMap extends PureComponent {
  constructor() {
    super();

    this.initMap = this.initMap.bind(this);
  }

  componentWillUpdate(nextProps) {
    if (this.googleMap && !isEqual(this.props.locations, nextProps.locations)) {
      this.updateMarkers(nextProps.locations, nextProps.vehicleType);
    }
  }

  initMap(googleMap) {
    if (!this.googleMap) {
      this.googleMap = googleMap;

      const { locations, contentWidth, vehicleType, safeZone } = this.props;

      const offset = getMapOffset(safeZone, contentWidth, this.mapContainerEl);

      this.googleMap.addMarkers(getMarkerIcon(locations, vehicleType));
      this.googleMap.zoomToMarkers({ safeZone, offset });
    }
  }

  updateMarkers(locations, vehicleType) {
    this.googleMap.updateMarkers(getMarkerIcon(locations, vehicleType));
  }

  render() {
    const { children } = this.props;

    return (
      <div className={styles['order-status-map']}>
        <div
          ref={(mapContainerEl) => {
            this.mapContainerEl = mapContainerEl;
          }}
          className={styles.map}
        >
          <GoogleMap onInit={this.initMap} />
        </div>
        {children}
      </div>
    );
  }
}

OrderStatusMap.propTypes = {
  safeZone: PropTypes.shape({
    top: PropTypes.number.isRequired,
    left: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
  }),
  locations: PropTypes.arrayOf(
    PropTypes.shape({
      location: PropTypes.object,
      type: PropTypes.string,
    }),
  ),
  vehicleType: PropTypes.string,
  contentWidth: PropTypes.number,
  children: PropTypes.node.isRequired,
};

OrderStatusMap.defaultProps = {
  vehicleType: null,
  contentWidth: 0,
  locations: [],
  safeZone: undefined,
};
